import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import BreakableTypography from 'components/@common/BreakableTypography';
import ProductIconList from 'components/@common/ProductIconList';
import StatItem from 'components/@common/StatItem';
import sumBy from 'lodash/sumBy';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import { Classroom } from 'types/schema-generated-types';

const useStyles = makeStyles(theme => {
  return {
    container: {
      padding: theme.spacing(2)
    },
    chip: {
      height: 16,
      textTransform: 'uppercase',
      fontWeight: 400,
      fontSize: 12,
      borderRadius: 4,
      color: 'white',
      background: '#107F79',
      marginLeft: theme.spacing(3),
      marginTop: -6
    }
  };
});

interface DetailBarProps {
  classroom: Classroom;
}

const DetailBar: React.FC<DetailBarProps> = ({ classroom }) => {
  const classes = useStyles();
  const { t } = useTranslation('DetailBar');

  const assignedCount = classroom.licenseUsage ? sumBy(classroom.licenseUsage, 'assignedCount') : 0;

  return (
    <Grid container spacing={2} component={Paper} className={classes.container}>
      <Grid item container direction="column" xs={12} md={3}>
        <Grid item>
          <BreakableTypography variant="h3">
            {classroom.name}
            <Chip size="small" label="CLASS" className={classes.chip} />
          </BreakableTypography>
        </Grid>
        <Grid item>
          <Typography variant="subtitle1">
            {classroom.organization?.parentOrganization?.name}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12} md>
        <StatItem title={t('Students', { ns: '@common' })} count={classroom.stats?.studentCount} />
      </Grid>
      <Grid item xs={12} md>
        <StatItem title={t('Educators', { ns: '@common' })} count={classroom.stats?.userCount} />
      </Grid>
      <Grid item xs={12} md>
        <StatItem title={t('Assigned Licenses')} count={assignedCount} />
      </Grid>
      <Grid item xs={12} md>
        <StatItem
          title={t('Products Used')}
          count={0}
          renderCount={(): ReactElement => (
            <ProductIconList style={{ minWidth: 120 }} licenseUsage={classroom.licenseUsage} />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default DetailBar;
